import { createModel } from '@rematch/core';
import { DEFAULT_VALUE_0 } from 'common/config';
import { IRootModel } from 'app/store';
import { IPatientMetricsState } from 'entities/PatientMetrics/PatientMetrics.models';
import { patientMetricsReducers } from 'entities/PatientMetrics/PatientMetrics.reducers';
import { patientMetricsEffects } from 'entities/PatientMetrics/PatientMetrics.effects';

export const patientMetrics = createModel<IRootModel>()({
  state: {
    data: [],
    count: DEFAULT_VALUE_0,
    loading: false,
  } as IPatientMetricsState,
  reducers: patientMetricsReducers,
  effects: patientMetricsEffects,
});
